export default __webpack_public_path__ + "static/media/a008-B.2f1d6ba3.svg";